<template>
  <div class="test-view">
    <div v-if="model" class="test-container">
      <div class="test-progress-container">
        <div class="progress-bar">
          <div
            class="progress-bar-value"
            :style="'width: ' + progress + '%;'"
          ></div>
        </div>
        <div class="timer-container">{{ elapsed | time }}</div>
      </div>
      <div v-if="!finished" class="question-container">
        <Question
          :question="question"
          :test-mode="true"
          :test-id="model.id"
          @answered="handleCorrectAnswer"
          @failed="handleFailedAnswer"
        />
      </div>
      <div v-else>
        <transition name="fade">
          <div class="test-result-container">
            <h1>Prüfung abgeschlossen</h1>
            <transition
              appear
              name="flipInX"
              enter-active-class="animated flipInX"
              leave-active-class="animated flipOutX"
            >
              <div v-if="passed" class="result success">Bestanden!</div>
              <BaseButton v-else class="result failed"
                >Leider nicht Bestanden!<br />Versuche es nochmals!</BaseButton
              >
            </transition>
            <div class="pct-results">{{ percentage }}%</div>
            <div class="point-results">
              <strong>{{ points }}</strong>
              <p>von</p>
              <strong>{{ model.totalPoints }}</strong>
              <p>Punkte</p>
            </div>
            <div class="result-table-container">
              <h2>Auswertung</h2>
              <table class="result-table">
                <thead>
                  <tr>
                    <th class="id">#</th>
                    <th colspan="2" class="text">Frage</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(q, index) in model.test">
                    <tr
                      :class="[selected == q.id ? 'active' : '']"
                      @click="showQuestion(q)"
                    >
                      <td class="id">{{ q.id }}</td>
                      <td class="text">{{ q.text.DE.question_text }}</td>
                      <td class="status">
                        <span v-if="q.correct">✓</span>
                        <span v-else>✖</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-else>
      <h2 class="loading-text">Prüfung wird generiert...</h2>
      <Spinner />
    </div>
  </div>
</template>

<script>
import axios from "@/http";
import Question from "@/components/Question";
import Spinner from "@/components/Spinner";
import BaseButton from "@/components/BaseButton";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TestView",
  components: {
    Question,
    Spinner,
    BaseButton,
  },
  data() {
    return {
      model: null,
      type: null,
      testModelId: null,
      loading: true,
      curQuestion: null,
      startTime: null,
      curTime: null,
      timer: null,
      curQuestionIndex: 0,
      finished: false,
      points: 0,
      showDetails: null,
      selected: null,
    };
  },
  computed: {
    question() {
      if (this.model && this.model.test) {
        return this.model.test[
          Object.keys(this.model.test)[this.curQuestionIndex]
        ];
      }
    },
    progress() {
      if (this.model.test) {
        if (!this.finished) {
          let max = Object.keys(this.model.test).length;
          return (this.curQuestionIndex / max) * 100;
        } else {
          return 100;
        }
      }
      return 0;
    },
    percentage() {
      if (this.model && this.points) {
        return ((this.points / this.model.totalPoints) * 100).toFixed(2);
      }
      return 0.0;
    },
    passed() {
      if (this.model) {
        return this.percentage >= parseInt(this.model.class_limit, 10);
      }
      return false;
    },
    timedOut() {},
    elapsed() {
      if (this.startTime && this.curTime) {
        return (this.curTime - this.startTime) / 1000;
      }
      return 0;
    },
    ...mapGetters(["tokenHeader"]),
  },
  watch: {
    finished(n, o) {
      if (n) {
        if (this.model && this.model.test_id) {
          this.gradeTest();
        }
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
    },
  },
  filters: {
    time(value) {
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    },
  },
  async mounted() {
    this.type = this.$route.params.type;
    switch (this.type) {
      case "grundwissen":
        this.testModelId = 300;
        break;
      case "b-fuehrerschein":
        this.testModelId = 302;
        break;
      default:
        this.testModelId = null;
    }
    this.setPageType("test");

    if (this.testModelId) {
      await this.loadTest();
      this.loading = false;
      this.startTime = Date.now();
      this.timer = setInterval(() => (this.curTime = Date.now()), 1000);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      console.info("stopping timer", this.timer);
      clearInterval(this.timer);
    }
  },
  methods: {
    async loadTest() {
      try {
        let result = await axios.get(
          process.env.VUE_APP_FLL_ROOT_API +
            "/tests/" +
            this.testModelId +
            "/test",
          {
            headers: {
              ...this.tokenHeader,
            },
          }
        );
        this.model = result.data[0];
      } catch (error) {
        // TODO: handle error
        console.error(error);  // eslint-disable-line
      }
    },
    async gradeTest() {
      if (this.model && this.model.test_id) {
        try {
          let result = await axios.get(
            process.env.VUE_APP_FLL_ROOT_API +
              "/tests/grade/" +
              this.model.test_id,
            {
              headers: {
                ...this.tokenHeader,
              },
            }
          );
        } catch (error) {
          // TODO: handle error
          console.error(error);  // eslint-disable-line
        }
      }
    },
    nextQuestion() {
      let cur = this.question;
      if (this.curQuestionIndex < this.model.totalQuestions - 1) {
        if (!this.question.correct) {
          for (
            let i = this.curQuestionIndex + 1;
            i < this.model.test.length;
            i++
          ) {
            this.curQuestionIndex = i;
            if (
              parseInt(this.model.test[i].follow_up_question_level, 10) === 0
            ) {
              break;
            }
            this.model.test[i].correct = false;
          }
        } else {
          this.curQuestionIndex++;
        }
      }

      if (this.curQuestionIndex === this.model.test.length - 1) {
        this.finished = true;
      }
    },
    handleCorrectAnswer(answerKey) {
      this.points += parseInt(this.question.points, 10);
      this.question.correct = true;
      this.question.user_answer_key = answerKey;
      this.nextQuestion();
    },
    handleFailedAnswer(answerKey) {
      this.question.correct = false;
      this.question.user_answer_key = answerKey;
      this.nextQuestion();
    },
    showQuestion(q) {
      this.selected = q.id;
      this.setCurSolution(q);
    },
    ...mapActions(["setPageType", "setCurSolution"]),
  },
};
</script>

<style lang="scss" scoped>
.test-view {
  .test-container {
    .test-progress-container {
      padding: 10px;
      background: $blue;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .timer-container {
        color: #ffffff;
        font-size: 20px;
      }

      .progress-bar {
        height: 20px;
        width: 75%;
        border-radius: 10px;
        border: 1px solid #ffffff;
        overflow: hidden;
        background: #ffffff;

        .progress-bar-value {
          transition: width 0.4s ease-in-out;
          background: $green;
          height: 100%;
        }
      }
    }
  }

  .loading-text {
    width: 100%;
    text-align: center;
    margin: 10px;
    padding: 20px;
  }

  .test-result-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

    .pct-results {
      font-size: 32px;
      margin: 20px 0;
      font-weight: bolder;
    }

    .point-results {
      display: flex;
      flex-direction: row;
      align-items: center;

      p {
        margin: 0 5px;
        font-size: 32px;
      }

      strong {
        font-weight: bold;
        font-size: 48px;
      }
    }

    strong {
      font-weight: bold;
    }

    .result-table-container {
      h2 {
        margin: 40px 0 20px 0;
        color: $green;
      }

      table.result-table {
        border-collapse: collapse;

        tr {
          th {
            color: #ffffff;
            background: $blue;
            padding: 5px;
            font-size: 15px;
            font-weight: normal;
            text-align: left;
          }

          td:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          td:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }

          &:first-child {
            td {
              border-top-left-radius: 0px;
              border-top-right-radius: 0px;
            }
          }

          &:hover,
          &.active {
            td {
              background: $green;
              color: #ffffff;
              cursor: pointer;

              span {
                color: #ffffff;
              }
            }
          }
        }

        td {
          padding: 5px;
          vertical-align: top;
        }

        .id {
          text-align: right;
        }

        .text {
          width: 100%;
        }

        .status {
          text-align: right;
          font-size: 22px;
        }
      }
    }

    .result {
      padding: 10%;
      font-size: 24px;
      color: #fff;
      width: 80%;
      text-align: center;
      font-weight: bold;
      margin-top: 20px;
      border-radius: 5px;
    }

    .success {
      color: #ffffff;
      background: #00ff00;
    }

    .failed {
      color: #ffffff;
      /*background: #ff0000;*/
      background: $green;
    }
  }
}
</style>
